import { PrintType, ProductType } from "./types";

// to mirror the names used in shopify
export const printTypeToShopifyVariantName: Record<PrintType, string> = {
  [PrintType.poster30x40cm]: "Poster (30x40 cm)",
  [PrintType.posterFramed30x40cm]: "Gerahmtes Poster (30x40 cm)",
  [PrintType.galleryPrint]: "Gallery Print",
  [PrintType.poster]: "Poster",
  [PrintType.posterFramed]: "Gerahmtes Poster",
  [PrintType.digital]: "Digitaldatei",
  [PrintType.metalPrint]: "Metal Print",
};

export const productTypeToShopifyProductName: Record<ProductType, string> = {
  [ProductType.starmap]: "Sternenkarte",
  [ProductType.soundwave]: "Voice Poster",
  [ProductType.baby]: "Baby Print",
};

export const productTypeToShopifyProductTitle: Record<ProductType, string> = {
  [ProductType.starmap]: "STARMAP",
  [ProductType.soundwave]: "VOICE_POSTER",
  [ProductType.baby]: "BABY_POSTER",
};
